import win_one from "../../../assets/images/win_one.svg";
import win_two from "../../../assets/images/win_two.svg";
import win_three from "../../../assets/images/win_three.svg";
import win_four from "../../../assets/images/win_four.svg";
import win_five from "../../../assets/images/win_five.svg";
import rupee_currency from "../../../assets/images/rupee_currency.svg";
import { IListObj } from "../../types/genericTypes";
import moment from "moment";

export const DropdownOptions: Array<IListObj> = [
  { display: "NSE", value: "NSE" },
  { display: "CDS", value: "CDS" },
  { display: "BSE", value: "BSE" },
  { display: "NFO", value: "NFO" },
];

export const OrderTradeStates = {
  ORDER: "Order",
  TRADE: "Trade",
};

export const Segments = {
  Total: "Total",
  Currency: "Currency",
  Derivatives: "Derivatives",
  Cash: "Cash",
};

export const weeklyDataValue = 14;

export const ranges = {
  Today: [moment().toLocaleString(), moment().toLocaleString()],
  last_7_days: [
    moment().subtract(6, "days").toLocaleString(),
    moment().toLocaleString(),
  ],
  last_30_days: [
    moment().subtract(29, "days").toLocaleString(),
    moment().toLocaleString(),
  ],
  this_month: [
    moment().startOf("month").toLocaleString(),
    moment().toLocaleString(),
  ],
  last_month: [
    moment().subtract(1, "month").startOf("month").toLocaleString(),
    moment().subtract(1, "month").endOf("month").toLocaleString(),
  ],
};

export const handleTickInterval = (dataLength: number) => {
  if (dataLength <= 4) {
    return 0;
  } else if (dataLength <= 8) {
    return 2;
  } else if (dataLength <= 12) {
    return 3;
  } else if (dataLength <= 16) {
    return 4;
  }
};

export const VolumeStateOptions: Array<IListObj> = [
  { display: OrderTradeStates.ORDER, value: OrderTradeStates.ORDER },
  { display: OrderTradeStates.TRADE, value: OrderTradeStates.TRADE },
];

export const VolumeSegmentsOptions: Array<IListObj> = [
  { display: Segments.Currency, value: Segments.Currency },
  { display: Segments.Derivatives, value: Segments.Derivatives },
  { display: Segments.Cash, value: Segments.Cash },
];

export const convertRS = (val: number, fix: number) => {
  let result: string | number = val;
  if (val >= 10000000) {
    result = (val / 10000000).toFixed(fix) + "Cr";
  } else if (val >= 100000) {
    result = (val / 100000).toFixed(fix) + "L";
    console.log(result);
  } else if (val >= 1000) {
    result = (val / 1000).toFixed(fix) + "K";
  }
  return result;
};

export interface DateType {
  frmDt: Date;
  toDt: Date;
}

export const TopLeadersImg = [win_one, win_two, win_three, win_four, win_five];

export const TopSales = [
  {
    img: rupee_currency,
    total: "10000",
    date: "26 Oct 2021",
  },
  {
    img: rupee_currency,
    total: "8000",
    date: "26 Oct 2021",
  },
  {
    img: rupee_currency,
    total: "7400",
    date: "18 Oct 2021",
  },
  {
    img: rupee_currency,
    total: "5000",
    date: " 17 Oct 2021",
  },
  {
    img: win_one,
    total: "1000",
    date: "15 Oct 2021",
  },
];
